
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/trending",
      function () {
        return require("private-next-pages/product/trending/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/trending"])
      });
    }
  